/**
 *  Compute mean
 */
export function mean(values) {
    if (values.length === 0) {
        return 0;
    }
    const total = values.reduce((prev, curr) => prev + curr, 0);
    return total / values.length;
}
